export default {
    state: {
        menu: [
            { product: true, title: 'Tax Compliance', bgcolor: 'ccompliance' },
            // { button: true, title: 'Create Analysis', href: '/tds/ar#add' },
            // {
            //   title: 'Dashboard', icon: 'mdi mdi-view-dashboard-outline', href: '/pbc/dashboard',
            // },
            { header: true, title: 'Analysis', icon: '/img/navicon/AccountsReceivable.svg' },
            {
                title: 'Accounts Receivable', href: '/tds/ar', right: "tds_ar_project"
            },
            {
                title: 'Accounts Payable', href: '/tds/ap', right: "tds_ap_project"
            },
            {
                title: 'Tax Compliance', href: '/tds/monthly', right: "tds_monthly"
            },
            { header: true, title: 'Manage', icon: '/img/navicon/VendorMaster.svg' },
            {
                title: 'Vendor Master', href: '/tds/vm',
            },
            {
                title: 'Input Parameters Config', href: '/tds/ipconfig', right: "tds_monthly", action: ["review", "add", "edit"]
            },
            {
                title: 'File Config ', href: '/tds/filelist', right: "tds_monthly", action: ["review", "add", "edit"]
            },
        ],
    },
    mutations: {
    },
    actions: {
    },
    getters: {

    },
}